import { render } from "./ShowCaseVertical.vue?vue&type=template&id=686f0003&scoped=true"
import script from "./ShowCaseVertical.vue?vue&type=script&lang=js"
export * from "./ShowCaseVertical.vue?vue&type=script&lang=js"

import "./ShowCaseVertical.vue?vue&type=style&index=0&id=686f0003&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686f0003"]])

export default __exports__